import { call, put, takeLatest } from "redux-saga/effects";
import { showAlert } from "../../alertSlice";
import { getTriggerConfigApi, saveTriggerConfigApi } from "../../../api/apiLists/workflow";
import {
  fetchTriggerConfigFailure,
  fetchTriggerConfigRequest,
  fetchTriggerConfigStart,
  fetchTriggerConfigSuccess,
  saveTriggerConfigFailure,
  saveTriggerConfigRequest,
  saveTriggerConfigStart,
  saveTriggerConfigSuccess
} from "../../slices/workflow";
import { callWorkflowApi, requireWhatsAppModuleAccess } from "./workflowSagaHelper";

function* handleFetchTriggerConfig(action) {
  if (!(yield call(requireWhatsAppModuleAccess))) return;

  try {
    yield put(fetchTriggerConfigStart());

    const req = action.payload || { operation: "GET_TRIGGER_CONFIG", payload: {} };
    const res = yield callWorkflowApi(getTriggerConfigApi, req);

    if (res?.status) {
      yield put(fetchTriggerConfigSuccess(res?.data || null));
      return;
    }

    yield put(fetchTriggerConfigFailure(res?.errMsg || "Failed to load trigger config"));
  } catch (error) {
    yield put(fetchTriggerConfigFailure(error.message || "Failed to load trigger config"));
  }
}

function* handleSaveTriggerConfig(action) {
  if (!(yield call(requireWhatsAppModuleAccess))) return;

  try {
    yield put(saveTriggerConfigStart());

    const req = action.payload || { operation: "SAVE_TRIGGER_CONFIG", payload: {} };
    const res = yield callWorkflowApi(saveTriggerConfigApi, req);

    if (res?.status) {
      yield put(saveTriggerConfigSuccess(res?.data || null));
      yield put(showAlert({
        message: res?.data?.message || "Trigger config updated successfully.",
        type: "success"
      }));
      yield put(fetchTriggerConfigRequest({ operation: "GET_TRIGGER_CONFIG", payload: {} }));
      return;
    }

    const errMsg = res?.errMsg || "Failed to save trigger config";
    yield put(saveTriggerConfigFailure(errMsg));
    yield put(showAlert({ message: errMsg, type: "error" }));
  } catch (error) {
    const errMsg = error.message || "Failed to save trigger config";
    yield put(saveTriggerConfigFailure(errMsg));
    yield put(showAlert({ message: errMsg, type: "error" }));
  }
}

export default function* workflowTriggerSaga() {
  yield takeLatest(fetchTriggerConfigRequest.type, handleFetchTriggerConfig);
  yield takeLatest(saveTriggerConfigRequest.type, handleSaveTriggerConfig);
}
